import React, { useMemo } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Menu from "aldoo-ra/Menu"
import { shareOnFacebook } from "./share-providers/facebook"
import { shareOnX } from "./share-providers/x"
import { shareOnLinkedIn } from "./share-providers/linkedin"
import { shareOnReddit } from "./share-providers/reddit"
import { copyContent } from "./share-providers/copy"
import Localization from "aldoo-ra/Localization"

const BlogSharePanel = ({ url: propUrl, title }) => {
  const { lt } = Localization()
  // Use memoized value for URL with fallback
  const url = useMemo(() => propUrl || (typeof window !== 'undefined' ? window.location.href : ''), [propUrl])

  // Define the action map
  const actionMap = {
    "facebook.share": () => shareOnFacebook(url, title),
    "x.share": () => shareOnX(url, title),
    "linkedin.share": () => shareOnLinkedIn(url, title),
    "reddit.share": () => shareOnReddit(url, title),
    "content.copy": async () =>
      await copyContent(url, await lt("link_copied_to_clipboard")),
  }

  return (
    <div>
      <CMSRender
        contentType="MenuItem"
        match={{ "content.name": "BlogSharePanel" }}
        renderItem={(item, id) => {
          return (
            <Menu
              key={id}
              actionMap={actionMap}
              menuData={item}
              renderAs="hlist.icons"
              styleOverrides={{
                menu: "h-7 flex items-center gap-12 md:gap-14 my-0",
                menu_item: "w-auto h-7 my-0 py-0",
              }}
            />
          )
        }}
      />
    </div>
  )
}

//deploy 17
export default BlogSharePanel